/**
 * Mps Form Table 의 테마 선언입니다.
 */
const FORM_TABLE_THEME = {
    DEFAULT: undefined,
};

export {FORM_TABLE_THEME};